import { validateTidalLicense } from "../../base/index.js";
import { repeat } from "./repeat.js";
function padLeft(source, minLen, ch = " ") {
  return source.length < minLen ? repeat(ch, minLen - source.length) + source : source;
}
validateTidalLicense();
export {
  padLeft
};
//# sourceMappingURL=padLeft.js.map
